import { Component, OnInit, OnDestroy } from '@angular/core';
import { DataIoService } from '../../../../services/data-io.service';
import { MenuService } from '../../../../services/menu.service';
import { TranslationService } from '../../../../services/translation.service';
import {  ValueChangedConfirmation } from '../../../../classes/ValueChangedConfirmation';
import { TimeFrame, TimeFrameManager, Helper } from '../../../../classes';
@Component({
	selector: 'app-day-planner',
	templateUrl: './day-planner.component.html',
	styleUrls: ['./day-planner.component.scss']
})
export class DayPlannerComponent implements OnInit,OnDestroy {
	_debug:boolean = false;
	table:string="heating";
	eventSubscription:any;
	
	debug(msg:string){
		if(this._debug){
			console.log("DayPlannerComponent: "+msg);
		}
	}
	currentTime : Date;
	currentTimeFrame : TimeFrame;
	title:string;
	subtitle:string;
	zone:string;
	day:number;
	mode:string;
	id:number;
	stage:string;
	hours : Array<number>;
	left="-15%";
	_left=15;
	timeframes : Array<TimeFrame>;
	virtualFrame : TimeFrame;

	
	createDate(hour,minute){

		let date = new Date();
		if(minute == 60){
			date.setHours(hour+1);	
			date.setMinutes(0);
		}else{
			date.setHours(hour);
			date.setMinutes(minute);
		}
		date.setSeconds(0);
		date.setMilliseconds(0);
		return date;
	}

	getBackground(hour,minute){
		let date = this.createDate(hour,minute);
		
		if(this.stage == "start_time"){
			
			let fm = this.frameManager.getTimeFrame(this.day,date);
			if(fm == null){
				return 'black';
			}
			if(fm.getId() == this.virtualFrame.getId()){
				return 'black';
			}else{
				return 'grey';
			}
		
		}else{
			if(this.virtualFrame.contains(date)){
				return 'white';
			}
			let fm = this.frameManager.getTimeFrame(this.day,date);
			if(fm == null){
				return 'black';
			}
			if(fm.getId() != this.virtualFrame.getId()){
				return 'grey';
			}
		}


	}
	getCurrentTime(){
		return this.currentTime;
	}
	constructor(private menuService: MenuService, private ioService: DataIoService, private translator : TranslationService) {
		this.debug("constructing DayPlannerComponent.");
		this.hours = new Array<number>();
		for(let i=0;i<=24;i++){
			this.hours.push(i);
		}
		this._left = 15;
		this.left = this._left+"%";
		this.debug("constructed.");
	}

    pans=0;
    panSkip=1;
	eventHandler(event){
		this.debug("Event:"+event);
		switch(event){
			case 'panup':{
				this.pans=(++this.pans%this.panSkip);
                if(this.pans != 0){
                    return;
                }
			}
			case 'up':{
				let newCurrentTime = new Date(this.currentTime.getTime()+(10*60*1000));
				if(newCurrentTime.getDate() != this.currentTime.getDate()){
					/*
					this.currentTime.setMinutes(59);
					this.currentTime.setSeconds(59);
					this.currentTime.setMilliseconds(0);
					*/
				}else{
					this.currentTime = newCurrentTime;
				}
				

				break;
			}
			case 'pandown':{
				this.pans=(++this.pans%this.panSkip);
                if(this.pans != 0){
                    break;
                }
			}
			case 'down':{

				let newCurrentTime = new Date(this.currentTime.getTime()-(10*60*1000));
				if(newCurrentTime.getMinutes() == 49){
					newCurrentTime.setMinutes(50);
					newCurrentTime.setSeconds(0);
					newCurrentTime.setMilliseconds(0);
				}
				if(newCurrentTime.getDate() != this.currentTime.getDate()){
					break;
				}
				if(this.stage == "end_time"){
					if(newCurrentTime.getTime() < this.currentTimeFrame.getBegin().getTime()){
						break;
					}
				}
				this.currentTime = new Date(newCurrentTime);
				break;
			}
			case 'back':{
				this.ioService.setCurrentTimeFrame(null);
				this.menuService.historyBack();
				return;
			}
			case 'confirm':{
				if(this.hasConflict()){
					this.conflict = this.hasConflict();
					break;
				}

				if(this.stage == "start_time"){
					this.stage = "end_time";
					this.title = this.translator.tr("TIMEWINDOWS_EDITOR_END");
					if(this.currentTimeFrame == null){
						return;
					}
					this.currentTimeFrame.setBegin(this.currentTime);
					this.virtualFrame.setBegin(this.currentTime);
					let hours = Helper.twoDigits(this.currentTime.getHours());
					let minutes = Helper.twoDigits(this.currentTime.getMinutes());
					this.subtitle = (hours+":"+minutes);
					this.currentTime = new Date(this.currentTime.getTime()+3*60*60*1000);	
					this.currentTime.setSeconds(0);
					this.currentTime.setMilliseconds(0);
					break;		
				}
				if(this.stage == "end_time"){
					// leere zeiträume verhindern.
					if(this.currentTime.getHours() == this.currentTimeFrame.getBegin().getHours() && this.currentTime.getMinutes() == this.currentTimeFrame.getBegin().getMinutes()){
						return;
					}
					this.currentTimeFrame.setEnd(this.currentTime);

					this.ioService.setCurrentTimeFrame(this.currentTimeFrame);
					let tempWidget = this.menuService.findItem('dayplanner-temperature-setter');
					
					if(this.withTemperature()){
						console.log("adding timeframe with temperature.");
						tempWidget.set("zone",this.zone);
						tempWidget.set("table",this.table);
						tempWidget.set("day",this.day);
						tempWidget.set('mode',this.mode);
						tempWidget.set('id',this.id);
						this.debug("setting value to "+this.currentTimeFrame.getValue());
						
						this.currentTimeFrame.setIgnoreTemperature(false);
						if(this.menuService.getCurrentNode().isDescendantOf('schaltuhr_heizen')){
							this.currentTimeFrame.setIgnoreTemperature(true);
						}
						tempWidget.set('value',this.currentTimeFrame.getValue());
						tempWidget.setType('timeframe-temperature');
						tempWidget.setOnConfirmAction("set:currentTimeFrame.temperature");
						tempWidget.setTarget(this.menuService.getCurrentNode().target);
						

						this.menuService.goto(tempWidget);
						return;
					}else{
						console.log("adding timeframe without temperature.");
						if(this.mode == "add"){
							this.currentTimeFrame.setDay(this.day);
							this.debug("ADDING TIMEFRAME"+ this.currentTimeFrame.toString(true));
							this.frameManager.addTimeFrame(this.currentTimeFrame);
						}else{
							this.debug("PATCHING TIMEFRAME");
							this.frameManager.patch(this.id,this.currentTimeFrame);
						}
						let confirmation = new ValueChangedConfirmation('timeframe','0','1',this.menuService.getCurrentNode());
						this.menuService.historyBack(confirmation);
					}
				}
				return;
			}
		}

		this.virtualFrame.copy(this.currentTimeFrame);
		if(this.mode == 'start_time'){
			this.virtualFrame.setBegin(this.currentTime);

		}else{
			this.virtualFrame.setEnd(this.currentTime);
		}
		this.conflict = this.hasConflict();
		this.adjustSlider();
	}
	withTemperature():boolean{
			return  this.table == 'heating' && (this.ignore != 'temperature');
		}
		
	adjustSlider(){

		let currentPercentage = (this.currentTime.getHours()+(this.currentTime.getMinutes()/60))/24.0;
		if(this.stage == 'start_time'){
			this._left = 15;
		}else{
			this._left = 79;
		}
		let hourWidth = 10.3;
		let hourGap=1;
		let hourCombined = hourWidth+hourGap;
			
		this._left -= (this.currentTime.getHours()*(hourWidth+hourGap))+(this.currentTime.getMinutes()/60.0)*hourWidth;
		
		this.left=this._left+"%";
	}
	hasConflict(){

		
		let timeFrame = (this.frameManager.getTimeFrame(this.day,this.currentTime));
		if(this.stage == 'start_time'){
			if(!timeFrame){
				this.conflict = false;
				return false;
				
			}
			if(timeFrame.getId() == this.currentTimeFrame.getId()){
				this.conflict = false;
				return false;
			}
			if(timeFrame.toNumber(timeFrame.getEnd()) == timeFrame.toNumber(this.currentTime)){
				this.conflict = false;
				return false;
			}
			return true;
		}
		if(this.stage == "end_time"){
			for(let fm of this.frameManager.getTimeFrames(this.day)){
				if(fm.getId() != this.virtualFrame.getId() && fm.overlapsWith(this.virtualFrame)){
					this.debug("Overlapping: "+this.virtualFrame.toString() + " and "+ fm.toString());
					this.conflict=true;
					return true;				
				}
			}
			this.conflict = false;
			return false;
		}
		

	}
	conflict=false;
	frameManager:TimeFrameManager;
	ignore:string="";
	ngOnInit() {

		this.debug("initializing day-planner.");
		let element = this.menuService.getCurrentNode();
		this.zone = (element.get('zone'));
		this.mode = element.get('mode');
		this.ignore = element.get('ignore');
		console.log("this.ignore: "+this.ignore);
		this.day = parseInt(element.get('day'));
		this.id = parseInt(element.get('id'));
		this.table = element.get('table');
		this.debug("Mode: "+this.mode);
		this.debug("Zone: "+this.zone);
		this.debug("Day: "+this.day);
		this.debug("ID: "+this.id);
		this.debug("Ignore: "+this.ignore);
		this.currentTime = new Date();
		this.virtualFrame = new TimeFrame();
		this.frameManager = this.ioService.deviceInfo().getZoneById(parseInt(this.zone)).getTimeFrameManager(this.table);
		this.debug("Getting zonemanager for "+this.zone+" and "+this.table);
		if(this.frameManager == null|| this.frameManager==undefined){
			this.debug("Error: ZoneManager is null for "+this.zone);
		}
		if(this.mode == "add"){

			this.currentTimeFrame = new TimeFrame();
			this.title = this.translator.tr("TIMEWINDOWS_EDITOR_START");
			this.subtitle = '';
			this.ioService.setCurrentTimeFrame(new TimeFrame());

			this.currentTime.setHours(6);
			this.currentTime.setMinutes(0);
			this.stage = 'start_time';

		}
		if(this.mode == "edit"){
			let frameManager = this.ioService.deviceInfo().getZoneById(parseInt(this.zone)).getTimeFrameManager(this.table)
			this.debug("Getting zonemanager for "+this.zone+" and "+this.table);
			let dayFrames = frameManager.getTimeFrames(this.day);
			if(dayFrames == null){
				this.debug("Error: no frames found, but edit is enabled.");
			}
			for(let frame of dayFrames){
				if((frame.getId()+"") == (this.id+"")){
					this.currentTimeFrame = frame;
					this.virtualFrame.copy(frame);
					this.virtualFrame.setId(frame.getId());
				}else{
					this.debug("ignoring Timeframe for "+this.table+ " on zone "+this.zone+ " to edit "+frame.toString()+ " with id "+frame.getId() + " while looking for "+this.id);
				}
			}
			if(this.currentTimeFrame == null|| this.currentTimeFrame == undefined){
				this.debug("Found NO !Timeframe for "+this.table +" on zone "+this.zone+ " to edit.");
			}

			this.title = this.translator.tr("TIMEWINDOWS_EDITOR_START");
			this.subtitle = '';
			this.ioService.setCurrentTimeFrame(this.currentTimeFrame);
			this.currentTime.setHours(6);
			this.currentTime.setMinutes(0);
			this.stage = 'start_time';
		}

		this.eventSubscription = this.ioService.inputs.events$.subscribe(
            (event)=>{this.eventHandler(event);}
        );


		this.conflict = this.hasConflict();
		this.adjustSlider();
	}
	ngOnDestroy(){
		if(this.eventSubscription){
			this.eventSubscription.unsubscribe();
		}
	}

}
